import { View } from './view';
import { PaginationProps } from './model';

export const Pagination = (props: PaginationProps) => {
    return <View {...props} />;
};
